var _path, _path2, _path3, _path4, _g, _path5, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtDebtSmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.916 33.704s15.424-1.301 14.93-1.32c-.502-.023-12.114 6.02-12.114 6.02l4.235 8.507-8.905-4.92-6.297 8.105 1.655-7.279-13.914 5.42 11.244-9.019-17.691-8.902 18.916 4.67-5.044-11.36 6.791 6.654 4.027-13.765.109 14.536 9.12-10.19-7.064 12.843h.002z",
    fill: "#FFD32D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    opacity: 0.4,
    d: "m36.352 36.696 6.404-1.779-4.802 4.021 4.416 5.832-6.71-3.816-4.571 7.069 1.642-6.704-4.892.838 4.609-3.712-4.219-2.308 5.303.572.212-6.602z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38.455 47.04 5.135 9.48a17.008 17.008 0 0 1-3.966 3.227c-8.085 4.775-18.536 2.133-23.34-5.9-3.547-5.931-3.027-13.14.74-18.43l5.425.726 2.6 3.68.713 1.01 1.73 2.449.833 1.178.822 1.164 1.948.296 1.403.214 5.957.907v-.001z",
    fill: "#1B7690"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.448 47.202c-4.131-3.171-7.71 1.865-7.71 1.865 4.74 7.138 8.744 8.515 8.744 8.515 1.949-1.85 3.095-7.208-1.034-10.38zm.23 8.323s-4.29-3.703-6.075-6.158c0 0 2.32-3.463 5.75.112 2.704 2.81.324 6.046.324 6.046h.002zM32.499 46.133c-.607.787-1.88 2.39-3.027 3.483 0 0-4.573-3.159-7.265-6.402l2.843-3.392.713 1.01-1.85 2.298s.999.968 2.285 2.115c.282-.461.751-1.208 1.297-1.963l.833 1.179c-.366.47-.807 1.01-1.278 1.538.863.746 1.777 1.502 2.572 2.073l1.476-2.151 1.402.213-.001-.001z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "m38.448 20.384-.82-1.705 1.79-1.187.224 2.67zM39.717 12.821v-1.853l1.268-.223-.074 1.853zM13.077 33.508l-2.163.37-.522 1.187 1.417.37.746-.816zM10.392 16.454 8.75 15.49l.97-.815.97.667zM14.952 19.072l.625.176-.46.739-.461-.458zM29.533 19.57l.57.535-.603.38-.317-.538zM40.721 31.913l.184-.916.737.208-.322.708zM25.454 38.538l.768.12-.45.795-.471-.238zM30.496 11.622l.068-.76.853.072-.443.842zM26.694 8.815l.575-.065-.267 1.109-.565-.187-.09-.465zM21.472 32.816v-.841l.922-.075-.17.868zM15.479 33.144l-.382.363.29.552.595-.137.213-.57z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EEBFA1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.088.88S.18.348.355.146C.53-.054.834.074.834.074S.345.925.088.88z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(23.344 24.487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.54.972S.455.496.787.341c.322-.165.322.073.322.073S.751.935.54.972z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(23.344 24.487)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.718.072S1.138.526.99 1C.99 1 .769.77.916.398c.148-.364.802-.326.802-.326z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(12.32 12.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.336.007S.746.462.599.935C.6.935.387.705.525.34c.148-.37.81-.333.81-.333z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(12.32 12.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.77 0S.346.466.245.93c0 0-.166-.22-.056-.592C.3-.033.77.001.77.001z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(12.32 12.19)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.06 32.828s10.297 13.011 18.103 22.499c0 0-12.545-15.774-18.103-22.5zM28.348 28.79s7.195 9.17 12.673 15.775c0 0-8.768-11.095-12.673-15.774zM39.45 39.28s8.703 10.979 15.29 18.999c0 0-10.601-13.314-15.29-19zM30.392 33.966S40.69 46.975 48.494 56.464c0 0-12.548-15.778-18.102-22.498zM29.825 25.71S40.13 38.722 47.934 48.212c0 0-12.549-15.778-18.109-22.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.247 29.344s10.297 13.012 18.102 22.498c0 0-12.545-15.773-18.102-22.498zM22.576 30.478s10.297 13.01 18.103 22.5c0 0-12.547-15.776-18.103-22.5zM20.536 25.307s7.192 9.164 12.672 15.773c0 0-8.771-11.095-12.672-15.773z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.63 40.204c-2.034 7.318-8.606 12.178-15.86 12.411l3.326-10.247-3.466-4.897-.816-1.154-1.134-1.602.275-1.394.279-1.414.58-2.936.239-1.21.87-4.412-3.23-4.392a17.084 17.084 0 0 1 7.059.429c9.065 2.489 14.383 11.81 11.879 20.818z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.683 28.894-.87.077.239-1.21.706-.05zM44.528 31.764l.137 1.338s-.712.115-1.712.219l.28-1.414c.427-.061.869-.114 1.295-.143zM45.22 37.4s-.222.03-.591.07l-.817-1.153 1.29-.216.117 1.298.001.002zM52.307 34.39c-.007-2.343-3.002-2.322-3.083-2.322 2.453-.56 3.605-2.999 1.883-3.85-1.722-.855-4.467-.276-4.467-.276l.267 9.526c2.627.199 5.408-.702 5.4-3.079zm-4.48-5.777s2.628-.417 2.784.862c.156 1.28-2.67 1.925-2.67 1.925l-.115-2.787zm.127 7.892.013-3.352s3.247-.345 3.188 1.253c-.085 2.118-3.2 2.1-3.2 2.1zM52.767 28.393s2.872-.15 5.7.381l.048 1.197-2.254-.444.581 7.591-1.855.013.272-7.533-2.387.04-.107-1.247.002.002z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtDebtSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-debt-small.5535bddd761bc1ff6c0b2a8a125e8adc.svg";